import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fb",
  "use": "icon-fb-usage",
  "viewBox": "0 0 14 24",
  "content": "<symbol viewBox=\"0 0 14 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fb\">\n<path d=\"M11.4283 3.98118H13.8086V0.169411C13.4119 0.112941 12.0081 0 10.3602 0C6.9424 0 4.59263 1.97647 4.59263 5.64706V9.00706H0.808594V13.2706H4.56211V24H9.1701V13.2706H12.771L13.4119 9.00706H9.20061V6.07059C9.20061 4.82824 9.56681 3.98118 11.4283 3.98118Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol